import { toBaseLineItem } from "./base-line-item.js";
import { getLineItemProduct } from "../../../utils/mappers/view/visual-line-item/utils/get-line-item-product.js";
import { getLineItemAvailability } from "../../../../../../utils/utils/get-line-item-availability.js";
import { toBundleChildLineItem } from "../../../utils/mappers/view/visual-line-item/utils/map-bundle-child-line-items.js";
import { getLineItemImageUrl } from "../../../../../../utils/utils/get-line-item-image-url.js";
import { getProductA11yLabel } from "../../../utils/mappers/view/visual-line-item/utils/get-product-a11y-label.js";
import { getProductTitle } from "../../../utils/mappers/view/visual-line-item/utils/get-product-title.js";
const toNonPrescriptionBundleCartLineItem = (lineItem, intl, settings) => {
  const configurationBundleItem = lineItem.bundleLineItems.find(
    (item) => item.legacyProduct.productType === "configurationbundle"
  );
  if (!configurationBundleItem) {
    throw new Error("Configuration bundle not found");
  }
  const product = getLineItemProduct(lineItem);
  const variant = product.masterData.current.variant;
  return {
    ...toBaseLineItem(lineItem, settings, intl),
    type: "NON_PRESCRIPTION_BUNDLE",
    productType: "non-prescription-bundle",
    title: getProductTitle(product, intl),
    altText: getProductA11yLabel(lineItem, intl),
    imageUrl: getLineItemImageUrl(variant),
    sku: lineItem.sku,
    bundleChildLineItems: [toBundleChildLineItem(intl)(configurationBundleItem)],
    ...variant.availability ? { availability: getLineItemAvailability(variant.availability) } : {}
  };
};
export {
  toNonPrescriptionBundleCartLineItem
};
//# sourceMappingURL=non-prescription-bundle-line-item.js.map
